module.exports = __webpack_public_path__ + "img/contributions20On.4b70dfe0.svg";